import { Button, Flex, Text } from "@fluentui/react-northstar";
import React from "react";
import { useTranslation } from "react-i18next";

import { ResultsFinishTestButtonProps } from "./ResultsFinishTestButton.types";
import { useResultsFinishTestButtonStyles } from "./ResultsFinishTestButton.styles";

export const ResultsTestFinishedButton: React.FC<
  ResultsFinishTestButtonProps
> = ({ completeTest, isInfoFetched, isMobile }) => {
  const finishTestButtonStyles = useResultsFinishTestButtonStyles();
  const { t } = useTranslation();

  if (isMobile) {
    return (
      <Button
        className="focus-button"
        styles={finishTestButtonStyles.actionButton}
        data-testid="mobileFinishTest"
        onClick={completeTest}
        fluid
        primary
        disabled={!isInfoFetched}
        content={
          <Text
            styles={finishTestButtonStyles.finishTestText}
            content={<>{t("FINISH_TEST")}</>}
            size="large"
            weight="semibold"
            align="center"
          />
        }
      />
    );
  } else {
    return (
      <Flex padding="padding.medium">
        <Button
          data-testid="desktopFinishTest"
          styles={finishTestButtonStyles.actionButton}
          onClick={completeTest}
          fluid
          primary
          disabled={!isInfoFetched}
          content={
            <Text
              styles={finishTestButtonStyles.finishTestText}
              content={<>{t("DONE")}</>}
              size="large"
              align="center"
            />
          }
        />
      </Flex>
    );
  }
};
